export default {
  title: 'Illustrations pour les professionnels de la santé',
  metaDescription:
    "Visualisez l'anatomie humaine avec plus de 40 000 illustrations biologiques et scientifiques prêtes à l'emploi pour concevoir de superbes infographies et présentations scientifiques et éducatives",
  keywords:
    'illustration médicale, illustration médicale vectorielle, anatomie humaine visuelle, illustration biologique, illustration scientifique',
  exploreText: "...ou explorer toutes nos catégories d'illustrations (plus de 50)",
  showMore: 'Afficher plus',
  checkOutText: 'Découvrez notre variété de',
  createUniqueText:
    'des illustrations. Utilisez-les pour créer des illustrations scientifiques, académiques et éducatives uniques.',
  infographicsText: 'des infographies et des présentations.',

  // category illustrations
  Cardiology: 'Cardiologie',
  Neurology: 'Neurologie',
  Surgery: 'Chirurgie',
  Urology: 'Urologie',
  Gynecology: 'Gynécologie',
  Obstetrics: 'Obstétrique',
  Clinician: 'Clinicien',
  Pneumonology: 'Pneumonologie',
  Endocrinology: 'Endocrinologie',
  Orthopedics: 'Orthopédie',
  Pediatrics: 'Pédiatrie',
  Hematology: 'Hématologie',
  Immunology: 'Immunologie',
  Parasitology: 'Parasitologie',
  Nutrition: 'Nutrition',
  Odontology: 'Odontologie',
  Pharmacy: 'Pharmacie',
  Nursing: 'Soins infirmiers',
  Veterinary: 'Vétérinaire',
  Zoology: 'Zoologie',
  Botany: 'Botanique',
  'Cell biology': 'Biologie cellulaire',
  Development: 'Développement',
  Entomology: 'Entomologie',
  Ornithology: 'Ornithologie',
  Biochemistry: 'Biochimie',
  Chemistry: 'Chimie',
  Genetics: 'Génétique',
  'Molecular Biology': 'Biologie moléculaire',
  Nanotechnology: 'Nanotechnologie',
  Neuroscience: 'Neurosciences',
  Pharmacology: 'Pharmacologie',
  Toxicology: 'Toxicologie',
  'Earth Sciences': 'Sciences de la Terre',
  Education: 'Éducation',
  Engineering: 'Ingénierie',
  Geography: 'Géographie',
  'Physics & Astronomy': 'Physique et Astronomie',
  Oceanography: 'Océanographie',
  'Marine biology': 'Biologie marine',
  History: 'Histoire',
  'Others - Molecular Sciences': 'Autres - Sciences Moléculaires',
  Others: 'Autres',
};
